import React, { useEffect, useState } from "react";
import Grid from "../../Components/Grid";
import { Button, Input, Notification, Tag, toaster } from "rsuite";
import Responsive from "../../Components/Responsive";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import Label from "../../Components/Label";
import { APi, ERP_APi } from "../../Api";
import Swal from "sweetalert2";
import Translation from "../../translation/translation";
import format_number from "../../Helpers/number_formatter";
import moment from "moment";
import { AuthorizationStatus, serviceTypes } from "../../Constants/types";
import { useRecoilValue } from "recoil";
import { CCAsAtom } from "../../Atoms/cca.atom";
import { OperationTypeAtom } from "../../Atoms/operationTypes.atom";

const AllDeliveryBand = () => {
  const [montant, setMontant] = useState(0);
  const [bandList, setBandList] = useState();
  const [bandsToTransform, setBandsToTransform] = useState([]);
  const [bandsToTransformDefault, setBandsToTransformDefault] = useState([]);
  const ccas = useRecoilValue(CCAsAtom);
  const operationTypes = useRecoilValue(OperationTypeAtom);
  const [groupedBands, setGroupedBands] = useState({});
  const [totalDebit, setTotalDebit] = useState(0);
  const [data, setdata] = useState([]);

  const [filterModel, setFilterModel] = useState({
    q: "",
    service: 0,
    clientId: 0,
    representativeId: 0,
    checkoutId: 0,
    date: null,
    dateType: 0,
    status: 0,
    seasonId: 0,
    operationTypeId: 0,
    type: 0,
    statusTransaction: false,
    authorizationStatus: true,
  });

  const fetch = (_take) => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction, { ...filterModel })
      .fetchAll()
      .then((res) => {
        const { data } = res.data;

        const filteredData = data.filter(
          (item) => !(item.correctionTransactionId || item.errorTransactionId)
        );

        const sortedData = [...filteredData].sort(
          (a, b) => a.checkoutId - b.checkoutId
        );

        const transactionsToTransform = [];
        const finalFilteredData = [];

        sortedData.forEach((item) => {
          if (item.debit === 0) return;

          if (item.service === 1 && item.parentId === null) {
            transactionsToTransform.push(item.id);
          } else if (!(item.service === 1)) {
            finalFilteredData.push(item);
          }
        });

        setBandsToTransformDefault(transactionsToTransform);
        setdata(finalFilteredData);
        setTotalDebit(
          finalFilteredData.reduce((sum, item) => sum + item.debit, 0)
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    fetch();
  }, [filterModel]);

  const columns = [
    {
      value: "check",
      type: "checkbox",
      render: (v) => (
        <input
          type="checkbox"
          checked={v.isChecked}
          onChange={() => {
            checkPayment(v.index);
          }}
        />
      ),
    },
    {
      value: "sequentialNumber",
      name: "N.P",
      render: (nb) => <span>{nb || "-"}</span>,
    },
    {
      value: "ref",
      name: "Référence",
      render: (v) => <span>{v || "-"}</span>,
    },
    {
      value: "date",
      name: "Date",
      value2: "authorizationStatus",
      value3: "givedAuthorizationBy",

      render: (v, v2, givedAuthorizationBy) => (
        <h6
          style={{
            fontSize: "12px",
          }}
        >
          {moment(v).format("DD MMM YYYY")}
          <br></br>
          {v2 && v2 != 1 ? (
            <Tag
              size="sm"
              color={v2 == 2 ? "yellow" : v2 == 3 ? "green" : "red"}
            >
              <i
                style={{
                  fontWeight: "300",
                  fontSize: "12px",
                }}
              >
                {AuthorizationStatus.find((el) => el.value == v2)
                  ? AuthorizationStatus.find((el) => el.value == v2).label
                  : "-"}

                <i
                  style={{
                    color: "#f1f1f1",
                    fontSize: "12px",
                    display: "block",
                    marginTop: 0,
                  }}
                >
                  {ccas &&
                  givedAuthorizationBy &&
                  ccas.find((el) => el.id == givedAuthorizationBy)
                    ? ccas.find((el) => el.id == givedAuthorizationBy).name
                    : ""}
                </i>
              </i>
            </Tag>
          ) : (
            ""
          )}
        </h6>
      ),
    },
    {
      value: "representative",
      name: "Représentant",
      render: (v) => (
        <span style={{ color: "#223" }}>{v ? v.toUpperCase() : "-"}</span>
      ),
    },
    {
      value: "operationTypeId",
      name: "type",
      render: (v) =>
        v ? (
          <b
            style={{
              color: [
                "#330033",
                "#3c1053",
                "#334455",
                "#140d2e",
                "#334455",
                "#5a2c3e",
              ][operationTypes.findIndex((_) => _.id == v) / 6],
            }}
          >
            {operationTypes.find((el) => el.id == v)
              ? operationTypes.find((el) => el.id == v).designation
              : "Autres"}
          </b>
        ) : (
          "-"
        ),
    },
    {
      value: "debit",
      name: "Débit",
      render: (v) => (
        <b style={{ fontSize: "14px", color: "#549f0a" }}>
          {v ? format_number(v) : "-"}
        </b>
      ),
    },
    {
      value: "credit",
      name: "Crédit",
      render: (v) => (
        <b style={{ fontSize: "14px" }}>{v ? format_number(v) : "-"}</b>
      ),
    },

    {
      value: "designation",
      name: "designation",
      render: (v) => {
        return (
          <div
            style={{ maxWidth: "260px", overflow: "auto", fontSize: "13px" }}
          >
            {v || "-"}
          </div>
        );
      },
    },
    {
      value: "service",
      name: "Service",
      render: (v) =>
        v ? (
          <Tag
            color={
              v == 1
                ? "blue"
                : v == 2
                ? "green"
                : v == 3
                ? "red"
                : v == 4
                ? "black"
                : v == 5
                ? "orange"
                : v == 6
                ? "violet"
                : v == 7
                ? "yellow"
                : "teal"
            }
          >
            {serviceTypes.find((el) => el.value == v)
              ? serviceTypes.find((el) => el.value == v).label
              : "Autres"}
          </Tag>
        ) : (
          "-"
        ),
    },
    ,
    {
      value: "checkout",
      name: "Caisse",
      render: (v) => <b style={{ color: "#4c67c2" }}>{v ? v.name : "-"}</b>,
    },
  ];

  useEffect(() => {
    const newList = data.map((band, index) => ({
      ...band,
      check: {
        isChecked: bandsToTransform.includes(band.id),
        index: index,
      },
    }));

    const groupedBands = newList.reduce((acc, band) => {
      if (!acc[band.checkoutId]) acc[band.checkoutId] = [];
      acc[band.checkoutId].push(band);
      return acc;
    }, {});

    setBandList(newList);
    setGroupedBands(groupedBands);
  }, [data, bandsToTransform]);

  const checkPayment = (index) => {
    const updatedList = bandList.map((band) => {
      if (band.check.index === index) {
        const isChecked = !band.check.isChecked;
        const newAmount = isChecked
          ? montant + band.debit
          : montant - band.debit;

        if (newAmount >= 0) {
          band.check.isChecked = isChecked;
          setMontant(newAmount);

          if (isChecked) {
            setBandsToTransform((prev) => [...prev, band.id]);
          } else {
            setBandsToTransform((prev) => prev.filter((id) => id !== band.id));
          }
        }
      }
      return band;
    });

    setBandList(updatedList);
  };

  const handleSelect = () => {
    const resetList = bandList.map((band) => ({
      ...band,
      check: {
        ...band.check,
        isChecked: false,
      },
    }));

    let combinedSubset = [];
    let totalSum = 0;

    let groupedBandsCopy = JSON.parse(JSON.stringify(groupedBands));

    for (const checkoutId in groupedBandsCopy) {
      groupedBandsCopy[checkoutId].sort((a, b) => a.debit - b.debit);
    }

    const groupKeys = Object.keys(groupedBandsCopy).sort(
      (a, b) => parseInt(a) - parseInt(b)
    );

    while (true) {
      let addedInPass = false;

      for (const checkoutId of groupKeys) {
        const group = groupedBandsCopy[checkoutId];
        if (group.length === 0) continue;

        const band = group[0];
        if (totalSum + band.debit <= montant) {
          totalSum += band.debit;
          combinedSubset.push(band.id);
          groupedBandsCopy[checkoutId].shift();
          addedInPass = true;
        }
      }

      if (!addedInPass) {
        break;
      }
    }

    const updatedList = resetList.map((band) => {
      const isChecked = combinedSubset.includes(band.id);
      return {
        ...band,
        check: {
          ...band.check,
          isChecked,
        },
      };
    });

    const updatedBandsToTransform = combinedSubset;

    setBandList(updatedList);
    setBandsToTransform(updatedBandsToTransform);
    setMontant(totalSum);
  };

  const transformer = () => {
    const dvList = [...bandsToTransformDefault, ...bandsToTransform];
    ERP_APi.createERPApiEndpoint(
      "wind-billing/" + ERP_APi.ENDPOINTS_ERP.deliveryForm + "/transformDls"
    )
      .create({
        dvList: dvList,
      })
      .then((res) => {
        fetch();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Element a été bien ajouté !",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        toaster.push(
          <Notification type="error" header={Translation.errorHeader} closable>
            {error?.response?.data?.title ||
              error?.response?.data?.message ||
              Translation.error}
          </Notification>,
          { placement: "topEnd" }
        );
      });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "5px",
        }}
      >
        <div style={{ paddingRight: "10px" }}>
          <Responsive m={6} l={6} xl={12}>
            <Label>Montant totale : {format_number(totalDebit)} TND </Label>
          </Responsive>
        </div>
        <div>
          <Responsive m={6} l={6} xl={8}>
            <Input
              type="number"
              step="1"
              value={montant}
              onChange={(montant) => {
                setMontant(montant);
              }}
            />
          </Responsive>
        </div>
        <div>
          <Button onClick={handleSelect} appearance="primary">
            <span>
              <CheckRoundIcon /> Sélectionner{" "}
            </span>
          </Button>
        </div>
        {bandsToTransform.length > 0 && (
          <div style={{ marginLeft: "auto", textAlign: "right" }}>
            <Button
              onClick={transformer}
              style={{ margin: 5 }}
              appearance="primary"
            >
              Transformer
            </Button>
          </div>
        )}
      </div>
      <Grid noAdvancedActions columns={columns} rows={bandList} />
    </div>
  );
};

export default AllDeliveryBand;
